import type { IconName as FaPackIconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';

export type LegacyIconName =
  | 'triangle-warning'
  | 'user-lock'
  | 'truck'
  | 'cloud-download'
  | 'rewards-star'
  | 'graduation-cap'
  | 'calendar';

export type FaIconName =
  // ── Font Awesome 7 Pro · Regular ──────────────────────────────────────────
  | 'fa-regular-shipping-fast'
  | 'fa-regular-gift'
  | 'fa-regular-user-circle'
  | 'fa-regular-bell'
  | 'fa-regular-graduation-cap'
  | 'fa-regular-camera'
  | 'fa-regular-star'
  | 'fa-regular-calendar'
  | 'fa-regular-cloud-download'
  | 'fa-regular-user-plus'
  | 'fa-regular-eye'
  | 'fa-regular-eye-slash'
  | 'fa-regular-trash'
  | 'fa-regular-trash-can'
  | 'fa-regular-truck'
  | 'fa-regular-school'
  | 'fa-regular-hourglass-start'
  | 'fa-regular-envelope'
  | 'fa-regular-home'
  | 'fa-regular-mobile-alt'
  | 'fa-regular-edit'
  | 'fa-regular-book-heart'
  | 'fa-regular-badge-dollar'
  | 'fa-regular-triangle-exclamation'
  | 'fa-regular-lock'
  | 'fa-regular-cloud-arrow-down'
  // ── Font Awesome 7 Pro · Solid ────────────────────────────────────────────
  | 'fa-solid-user'
  | 'fa-solid-user-graduate'
  | 'fa-solid-gift'
  | 'fa-solid-trash'
  // ── Font Awesome 7 Sharp · Solid ──────────────────────────────────────────
  | 'fa-sharp-solid-chevron-right'
  | 'fa-sharp-solid-chevron-left'
  | 'fa-sharp-solid-chevron-down'
  | 'fa-sharp-solid-chevron-up'
  | 'fa-sharp-solid-times'
  | 'fa-sharp-solid-check'
  | 'fa-sharp-solid-arrow-up'
  | 'fa-sharp-solid-long-arrow-left'
  | 'fa-sharp-solid-long-arrow-right'
  | 'fa-sharp-solid-arrow-left'
  | 'fa-sharp-solid-arrow-right'
  | 'fa-sharp-solid-plus'
  | 'fa-sharp-solid-minus'
  | 'fa-sharp-solid-search'
  | 'fa-sharp-solid-check-circle'
  // ── Font Awesome 7 Sharp · Regular ────────────────────────────────────────
  | 'fa-sharp-regular-check-circle'
  | 'fa-sharp-regular-times'
  | 'fa-sharp-regular-times-circle'
  | 'fa-sharp-regular-question-circle'
  | 'fa-sharp-regular-info-circle'
  | 'fa-sharp-regular-shopping-cart'
  | 'fa-sharp-regular-circle-exclamation'
  | 'fa-sharp-regular-plus-circle';

export type IconName = LegacyIconName | FaIconName;

const FA_PREFIX = {
  light: 'fal',
  regular: 'far',
  solid: 'fas',
  duotone: 'fad',
  brands: 'fab',
  'sharp-solid': 'fass',
  'sharp-regular': 'fasr'
} as const satisfies Record<string, IconPrefix>;

export type FaIconRef = [IconPrefix, FaPackIconName];

export function parseFaIcon(name: IconName): FaIconRef | null {
  const m = /^fa-(light|regular|solid|duotone|brands|sharp-solid|sharp-regular)-(.+)$/.exec(name);
  return m ? [FA_PREFIX[m[1] as keyof typeof FA_PREFIX], m[2] as FaPackIconName] : null;
}
